import { scrollTo } from '@/utils';
import { useFormContext } from 'react-hook-form';
import { EpButton } from '../../../components';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { useTranslationStore } from '../../../stores';
import { goToPrevStep } from '../../EpWizard';

export const FormStepButtonBack = () => {
  const { translations } = useTranslationStore((state) => state);
  const { getValues } = useFormContext();
  const [activeStep, totalSteps] = getValues([
    'formUtils.activeStep',
    'formUtils.totalSteps',
  ]);

  const handleBackStep = () => {
    if (activeStep > 1) {
      goToPrevStep();
      scrollTo(['ep-card-default', 'ep-card__body--1', 'headerNavigationTestPopoverHost']);
    }
  };

  if (activeStep === 1 || activeStep === totalSteps) {
    return null;
  }

  return (
    <EpButton
      buttonId="step-back"
      buttonSize="md"
      buttonType="primary-outline"
      buttonText={t(translations['global'], 'Previous')}
      buttonLeftIconName="SolidLongArrowAltLeft"
      buttonOnClickFunc={handleBackStep}
    />
  );
};
